const CircleArrowLeft03Icon = /*#__PURE__*/ [
  ["path", { d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z", stroke: "currentColor", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M12.503 9.49156C11.9717 10.0219 9.99314 11.3138 10.0031 12.0592C10.0831 12.797 12.0043 13.975 12.509 14.4953M17.0016 11.9752L10.0085 11.9835M7.00286 16.002L6.99335 8.00995", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export { CircleArrowLeft03Icon as default };
//# sourceMappingURL=CircleArrowLeft03Icon.js.map
